/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleUpDown: {
  name: 'triangle-up-down';
  data: string;
} = {
  name: 'triangle-up-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.981 8h4.038c1.124.012 1.24-1 .563-1.66L12.78 4.343C12.5 4 12 4 12 4s-.5 0-.781.342l-1.8 1.999c-.678.658-.562 1.67.562 1.658Zm0 8h4.038c1.124-.012 1.24 1 .563 1.659l-1.801 1.998C12.5 20 12 20 12 20s-.5 0-.781-.343l-1.8-1.998C8.74 17 8.856 15.988 9.98 16Z" fill="currentColor"/></svg>`,
};
